import axios from "axios";

const API = `/api/jsa`;

export const getTodayJsa = (wellId, token) =>
  axios
    .get(`${API}/${wellId}/today`, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => res.data);

export const createJsa = (wellId, data, token) =>
  axios
    .post(`${API}/${wellId}`, data, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => res.data);

export const updateJsa = (id, data, token) =>
  axios
    .put(`${API}/${id}`, data, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => res.data);

export const lockJsa = (id, token) =>
  axios
    .put(
      `${API}/${id}/lock`,
      {},
      { headers: { Authorization: "Bearer " + token } },
    )
    .then((res) => res.data);

export const getJsaHistory = (wellId, token) =>
  axios
    .get(`${API}/${wellId}/history`, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => res.data);

export const exportJsaPdf = (id, token) => {
  fetch(`${API}/${id}/pdf`, { headers: { Authorization: "Bearer " + token } })
    .then((res) => res.blob())
    .then((blob) => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `JSA_${id}.pdf`;
      a.click();
      URL.revokeObjectURL(a.href);
    });
};
